import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-10 px-4" data-id="element-178">
      <div className="max-w-xl mx-auto text-center" data-id="element-179">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-black text-brand-cream mb-4" data-id="element-180">
          Der wahre versteckte Preis
        </motion.h2>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-base sm:text-lg text-gray-300 leading-relaxed space-y-4" data-id="element-181">
          <p data-id="element-182">Hören Sie auf, mit Ihrer Freizeit zu bezahlen.</p>
          <p data-id="element-183">
            Über{' '}
            <span className="text-brand-danger font-bold" data-id="element-184">
              1.500 CHF Verluste pro Saison
            </span>
            . Ohne System zahlen Sie jede Woche hunderte Franken zu viel.
          </p>
          <p data-id="element-185">
            Das sind Wochenenden, Abende und Momente mit der Familie, die nie
            wieder zurückkommen.
          </p>
        </motion.div>
      </div>
    </section>;
}